import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { of, tap, shareReplay, finalize } from 'rxjs';
import { CacheService } from '../../shared/services/cache.service';

export const cacheInterceptor: HttpInterceptorFn = (req, next) => {
  const cacheService = inject(CacheService);

  // URLs que nunca devem ser cacheadas (override manual)
  const blacklist = [
    '/api/list/card/free/',
    '/api/list/card/in-use/'
  ];

  // Verifica blacklist
  if (blacklist.some(url => req.url.includes(url))) {
    return next(req);
  }

  const isApiList = req.url.includes('/api/list/');

  // Se não for api/list/ e não for GET, passa direto
  if (req.method !== 'GET' || !isApiList) {
    return next(req);
  }

  // Verifica header X-No-Cache
  if (req.headers.has('X-No-Cache')) {
    return next(req);
  }

  const cacheKey = req.urlWithParams;

  // 1. Verifica no Cache (In-Memory)
  const cachedResponse = cacheService.get(cacheKey);
  if (cachedResponse) {
    return of(new HttpResponse({ body: cachedResponse, status: 200 }));
  }

  // 2. Verifica se já existe uma requisição em andamento (In-Flight)
  if (cacheService.inFlightRequests.has(cacheKey)) {
    return cacheService.inFlightRequests.get(cacheKey)!;
  }

  // 3. Faz a requisição, compartilha o resultado e salva no cache
  const request$ = next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        // Lê o TTL do header X-Cache-TTL ou usa padrão de 30s
        const ttl = req.headers.has('X-Cache-TTL') 
          ? parseInt(req.headers.get('X-Cache-TTL')!, 10)
          : 30;
        cacheService.set(cacheKey, event.body, ttl);
      }
    }),
    finalize(() => {
      // Quando completar (sucesso ou erro), remove do mapa de in-flight
      cacheService.inFlightRequests.delete(cacheKey);
    }),
    shareReplay(1) // Compartilha o resultado com inscritos tardios
  );

  // Registra a requisição em andamento
  cacheService.inFlightRequests.set(cacheKey, request$);

  return request$;
};
